import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Post from 'flarum/forum/components/Post';
import Button from 'flarum/common/components/Button';
import ItemList from 'flarum/common/utils/ItemList';
import PostControls from 'flarum/forum/utils/PostControls';
import humanTime from 'flarum/common/utils/humanTime';
import AlertUtil from 'flarum/forum/dianLiang/AlertUtil';

export default function () {
  extend(Post.prototype, 'elementAttrs', function (attrs) {
    
    if (app.forum.attribute('adminUrl') && this.attrs.post.number() == 1) {
      if (this.attrs.post?.discussion() && this.attrs.post?.discussion()?.isFronts() && this.attrs.post?.discussion()?.isFronts()?.is_deleted == 0) {
      attrs.className += ' Post--flagged';
        
      }
    }
    // if (this.attrs.post.flags().length) {
    //   attrs.className += ' Post--flagged';
    // }
  });

  Post.prototype.dismissFront = function (body) {
    const post = this.attrs.post;
    const isFronts = post.discussion().isFronts();
    return app.request({
      url: app.forum.attribute('apiUrl') + '/notifications/deleteFront/' + isFronts.id,
      method: 'post',
      // body: {
      //   input: this.input,
      //   locale: this.locale,
      //   ignoreExisting: !this.overrideExisting,
      // },
    }).then(result => {
      m.redraw();
      AlertUtil.onSuccess(app, app.translator.trans('dl_discussion_controller.forum.pushFrontModal.admin_submit_success'));
      app.discussions.refresh();
    });
    
  };

  Post.prototype.isFrontsAction = function (body) {
    const post = this.attrs.post;
    const isFronts = post.discussion().isFronts();
    return app.request({
      url: app.forum.attribute('apiUrl') + '/notifications/frontSuccess',
      method: 'GET',
      params: {
        isFronts: isFronts,
      },
    }).then(result => {
      m.redraw();
      AlertUtil.onSuccess(app, app.translator.trans('dl_discussion_controller.forum.pushFrontModal.admin_submit_success'));
      app.discussions.refresh();
    });
  };

  Post.prototype.frontActionItems = function () {
    const items = new ItemList();
    const post = this.attrs.post;
    const isFronts = post.discussion().isFronts();
    // const controls = PostControls.destructiveControls(post);

    // Object.keys(controls.items).forEach((k) => {
    //   const attrs = controls.get(k).attrs;

    //   attrs.className = 'Button';

    //   extend(attrs, 'onclick', () => this.dismissFront());
    // });

    // items.add('controls', <div className="ButtonGroup">{controls.toArray()}</div>);

    items.add(
      'isFronts',
      <Button className="Button" icon="far fa-eye-slash" onclick={this.isFrontsAction.bind(this)}>
        {app.translator.trans(`dl_discussion_controller.forum.pushFrontModal.${isFronts.type == 'pushFronted' ? 'success' : 'fail'}_front`)}
      </Button>,
      -90
    );

    items.add(
      'dismiss',
      <Button className="Button" icon="far fa-eye-slash" onclick={this.dismissFront.bind(this)}>
        {app.translator.trans(`dl_discussion_controller.forum.notices.dismiss_push_front_button`)}
      </Button>,
      -100
    );

    return items;
  };

  extend(Post.prototype, 'content', function (vdom) {
    const post = this.attrs.post;
    const isFronts = post.discussion().isFronts();
    
    if (!(app.forum.attribute('adminUrl') && post.number() == 1 && isFronts && isFronts.is_deleted == 0)) return;
    if (post.isHidden()) this.revealContent = true;

    vdom.unshift(
      <div className="Post-flagged">
        <div className="Post-flagged-flags">
          {/* {flags.map((flag) => ( */}
            <div className="Post-flagged-flag">{this.frontReason(isFronts)}</div>
          {/* ))} */}
        </div>
        <div className="Post-flagged-actions">{this.frontActionItems().toArray()}</div>
      </div>
    );
  });

  Post.prototype.frontReason = function (isFronts) {
    // if (isFronts.type() === 'user') {
      const username = app.store.getById('users', isFronts.from_user_id)?.nickname();
      const time = humanTime(isFronts.created_at);
      let title = isFronts.data.discussion.title;
      
      if (isFronts.type == 'pushFronted') {
        let addExp = isFronts.data.myObject.addExperience;
        let addIntegra = isFronts.data.myObject.addIntegra;
        return app.translator.trans('dl_discussion_controller.forum.notices.admin_text',
          {username:username,title:title,addExp:addExp,addIntegra:addIntegra});
      }else {
        return app.translator.trans('dl_discussion_controller.forum.notices.admin_pull_front_text',
          {username:username,title:title});
      }
      
  };
}
